<template>
    <PageLoading v-if="isLoading" />
    <div v-else class="main-wrap login-page">
        <div class="login-form column q-col-gutter-y-md justify-center">
            <h1>{{ $t('recover_password.title') }}</h1>
            <div class="tagline">
                {{ $t('recover_password.insert_your_registered_email') }}
            </div>
            <div class="col">
                <q-input
                    v-model.trim="user.email"
                    :label="$t('general.email')"
                    type="email"
                    bg-color="black"
                    filled
                    clearable
                    :error-message="emailErrors"
                    :error="emailErrors != ''"
                    @input="$v.user.email.$touch()"
                    @blur="$v.user.email.$touch()"
                />
            </div>
            <div class="col">
                <q-btn
                    class="login-btn"
                    :label="$t('actions.recover_password')"
                    text-color="white"
                    flat
                    :loading="isRecoveringPassword"
                    @click="recoverPassword"
                />
            </div>
        </div>
    </div>
</template>

<script>
import validations from '@/views/authentication/mixins/validations'
import PageLoading from '@/components/PageLoading'
import authenticationService from '@/services/authentication'

const loadingKeys = {
    fetchingPage: 'fetching-page',
    recoveringPassword: 'recovering-password',
}

export default {
    name: 'RecoverPassword',

    components: {
        PageLoading,
    },

    mixins: [validations],

    data() {
        return {
            user: {
                email: '',
            },
        }
    },

    computed: {
        isLoading() {
            return this.isRecoveringPassword
        },

        isRecoveringPassword() {
            return (
                this.loadings.filter(
                    (loading) => loading.key === loadingKeys.recoveringPassword
                ).length > 0
            )
        },
    },

    methods: {
        async recoverPassword() {
            this.$v.$touch()

            if (this.$v.user.email.$invalid || this.isRecoveringPassword) {
                return true
            }

            this.loadingAdd(loadingKeys.recoveringPassword)

            let parameters = {
                data: [
                    {
                        email: this.user.email,
                    },
                ],
            }

            let response = await authenticationService.forgotPassword(
                parameters
            )

            if (response.status === 200) {
                this.$router.push(this.$route.query.redirect || '/')
                this.$q.notify({
                    type: 'positive',
                    message: this.$t('notify.check_instructions_on_your_email'),
                })
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('errors.send_email_error'),
                })
            }

            this.loadingRemove(loadingKeys.recoveringPassword)
        },
    },
}
</script>
